import { useEffect, useState } from "react";
import { IconUser } from "./icons.jsx";

export function RatingAvatar({ name, url, fallbackUrl }) {
  const [index, setIndex] = useState(0);
  useEffect(() => setIndex(0), [url, fallbackUrl]);
  const urls = [url, fallbackUrl && fallbackUrl !== url ? fallbackUrl : null].filter(Boolean);
  const initial = name.match(/[A-Za-zА-Яа-яЁё0-9]/u)?.[0].toLocaleUpperCase("ru-RU");
  return <span className="mc-rating-avatar">
    {urls[index] ? <img src={urls[index]} alt="" loading="lazy" onError={() => setIndex(value => value + 1)} /> : initial || <IconUser aria-hidden="true" />}
  </span>;
}
